import EntryPoint from "Engine/EntryPoint";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import Relax from "../../../icarusWilds/src/server/Relax";
import RelaxModel from "Base/model/RelaxModel";

export default new class AutoPlaySettings {
    constructor() {
        this._count = -1;
        this._selectedCount = -1;
        this._possibleCounts = [];
        this._conditions = [];
        this._active = false;
        this._paused = false;

        this.addConditions();
        this.addListeners();
    }

    init() {
        this._possibleCounts = [10, 50, 100, 250, 500];/*EntryPoint.configData.autoPlayConfig.possibleCounts;*/
        this.resetCount();
        EntryPoint.AutoPlaySettings = this;
    }

    addListeners() {
        GlobalDispatcher.add('stateManager.stateChanged', this.onStateChanged, this);
        GlobalDispatcher.add('autoplay:setActive', this.onSetActive, this);
        GlobalDispatcher.add('autoplay:setPaused', this.onSetPaused, this);

        GlobalDispatcher.add('overlay:showed', this.onOverlayShowed, this);
        GlobalDispatcher.add('overlay:hided', this.onOverlayHided, this);

        GlobalDispatcher.add('preloaderController:loadingPreloaderComplete', this.loadingPreloaderComplete, this, -1);
    }

    loadingPreloaderComplete() {
        this._possibleCounts = RelaxModel.availableAutoPlayCounts;
        this.resetCount();
    }

    addConditions() {
        let condition = () => {
            return (EntryPoint.GameModel.balance <= 1000 || EntryPoint.GameModel.totalWin >= 100 || EntryPoint.GameModel.freeSpins);
        };
        this._conditions.push(condition);
    }

    onSetActive(event) {
        this.active = event.params;
    }

    onSetPaused(event) {
        this.paused = event.params;
    }

    onStateChanged(event) {
        if (!this.active || this.paused) {
            return;
        }
        switch (event.params) {
            case 'initState':

                break;
            case 'idleState':

                break;
            case 'requestRollingState':
                if (this.count > 0) {
                    this.count -= 1;
                }
                break;
            default:

                break;
        }
    }

    resetCount() {
        this.selectedCount = this.possibleCounts[0];
    }

    onOverlayShowed() {
        if (EntryPoint.GameModel.isFreeSpins) {
            return
        }
        this.paused = true;
    }

    onOverlayHided() {
        if (EntryPoint.GameModel.isFreeSpins) {
            return
        }
        this.paused = false;
    }

    get count() {
        return this._count;
    }

    set count(value) {
        this._count = value;
        GlobalDispatcher.dispatch('autoPlaySettings:countChanged', this.count);

        if (this.count === 0) {
            this.active = false;
        }
    }

    get possibleCounts() {
        return this._possibleCounts;
    }

    get active() {
        return this._active;
    }

    set active(value) {
        this._active = value;
        GlobalDispatcher.dispatch('autoPlaySettings:activeChanged', this.active);
    }

    get selectedCount() {
        return this._selectedCount;
    }

    set selectedCount(value) {
        this.count = value;
        this._selectedCount = value;
        GlobalDispatcher.dispatch('autoPlaySettings:selectedCountChanged', this.selectedCount);
    }

    get paused() {
        return this._paused;
    }

    set paused(value) {
        this._paused = value;
        GlobalDispatcher.dispatch('autoPlaySettings:pausedChanged', this.paused);
    }
}